// =============================================================================
// CurrentLotChip — the "which tipped pallet / delivery did this come from"
// field on a run's capture forms (new pallet, reject log).
//
// Defaults to the run's latest tip, so the ordinary flow costs no tap; one tap
// switches it when an operator is packing out a different lot than the one
// last tipped. Renders nothing when the run has no tips (nothing to choose —
// the row is written unassigned) and a static line when it has one.
// =============================================================================
import { useId } from 'react'
import { AUTO_LOT, type RunTipOption } from '@/hooks/useCurrentLot'
import { tipOptionLabel } from '@/lib/runLots'

export function CurrentLotChip({ tips, choice, onChange, noun }: {
  tips:     RunTipOption[]
  /** AUTO_LOT or a tipping_id. */
  choice:   string
  onChange: (v: string) => void
  /** What is being captured — read back in the hint. */
  noun:     'pallet' | 'reject'
}) {
  const id = useId()
  if (tips.length === 0) return null
  const latest = tips[0]
  if (tips.length === 1) {
    return (
      <p className="text-xs text-muted">
        Lot: <span className="text-fg-secondary">{latest.label}</span> — the only tip on this run; this {noun} is recorded against it.
      </p>
    )
  }
  return (
    <div>
      <label className="label" htmlFor={id}>Lot <span className="text-muted normal-case">· which tipped pallet or delivery this {noun} came from</span></label>
      <select id={id} className="field" value={choice} onChange={e => onChange(e.target.value)}>
        <option value={AUTO_LOT}>Latest tip · {latest.label}</option>
        {tips.map(t => (
          <option key={t.tipping_id} value={t.tipping_id}>{tipOptionLabel(t)}</option>
        ))}
      </select>
      <p className="text-[11px] text-muted mt-1">
        Remembered for this run on this device. Pick the lot the fruit actually came from — the Lots view on the run reads it per pallet.
      </p>
    </div>
  )
}
